'use client'

import React from 'react'
import PrimaryButton from '@/src/components/ui/primary-button'
import SecondaryButton from '@/src/components/ui/secondary-button'

interface TradeVisionHeroProps {
  title: string
  description: string
  ctaLabel: string
  ctaHref: string
}

export const TradeVisionHero: React.FC<TradeVisionHeroProps> = ({
  title,
  description,
  ctaLabel,
  ctaHref
}) => {
  return (
    <section className="px-4">
      <div className="max-w-container mx-auto">
        <div className="max-w-4xl space-y-7">
          <div className="space-y-4">
            <span className="text-label uppercase tracking-[0.18em] text-link-blue">
              Sportsbook margin and player intelligence
            </span>
            <h1 className="font-display text-hero tracking-[-0.03em] text-primary">
              {title}
            </h1>
            <p className="max-w-3xl text-base leading-8 text-muted md:text-copy-lg">
              {description}
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <PrimaryButton href={ctaHref} size="lg">
              {ctaLabel}
            </PrimaryButton>
            <SecondaryButton href="/pilot" size="lg">
              See the pilot
            </SecondaryButton>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TradeVisionHero
